export const ALL_ICONS = [
  'arrow-up-from-bracket',
  'calendar',
  'calendar-check',
  'caret-down-solid',
  'chevron-left',
  'chevron-right',
  'chevron-down',
  'chevron-up',
  'clock',
  'exclamation-triangle',
  'info-circle',
  'list-check',
  'location-crosshairs',
] as const;

export type IconName = (typeof ALL_ICONS)[number];

export type IconColor =
  | 'info'
  | 'success'
  | 'warning'
  | 'error'
  | 'primary'
  | 'secondary'
  | 'tertiary';

export type IconVariant = 'light' | 'dark';

export type IconProps = {
  name: IconName;
  iconSize?: `${number}px`;
  boxSize?: `${number}px`;
  color?: IconColor;
  variant?: IconVariant;
};
